import { createSelector } from "@reduxjs/toolkit";
import { selectUsername } from "slices/app/selectors";

export const selectPrompts = (state) => state.prompts;

export const selectPromptsData = (state) => state?.prompts.prompts;
export const selectPromptsIsEditing = (state) => state?.prompts.isEditing;

export const selectPromptsUsers = createSelector(
  [selectPrompts, selectUsername],
  (prompts, currentUsername) =>
    (prompts?.users || []).filter(
      ({ username }) => username !== currentUsername
    )
);

export const selectPromptsPanel = createSelector(
  [selectPrompts],
  (prompts) => prompts.promptsPanel
);

export const selectPromptsPanelMode = createSelector(
  [selectPromptsPanel],
  (panel) => panel.mode
);

export const selectPromptsPanelCategoryIndex = createSelector(
  [selectPromptsPanel],
  (panel) => panel.categoryIndex ?? -1
);

export const selectPromptsPanelCategory = createSelector(
  [selectPromptsData, selectPromptsPanelCategoryIndex],
  (categories, categoryIndex) => {
    return categories[categoryIndex];
  }
);

export const selectVisiPrompts = (state) => state?.prompts.visiPrompts;
export const selectPromptsIsLockedBy = (state) => state?.prompts.isLockedBy;
export const selectPromptsLockedByAnotherUser = (state) =>
  state?.prompts.lockedByAnotherUser;

export const selectSelectedRowIndex = createSelector(
  [selectPrompts],
  (prompts) => prompts?.selectedRowIndex ?? 0
);
